export default __webpack_public_path__ + "static/media/1.3ca94b7f.png";